import React, { useState, useCallback } from 'react';
import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';
import './LocationPicker.css';

const mapContainerStyle = {
    width: '100%',
    height: '400px',
    borderRadius: '12px',
    position: 'relative'
};

const LocationPicker = ({ initialPosition, onLocationChange, apiKey }) => {
    const [mapCenter, setMapCenter] = useState(initialPosition);

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: apiKey
    });

    const [mapRef, setMapRef] = useState(null);

    const onMapLoad = useCallback((map) => {
        setMapRef(map);
    }, []);

    // Update coordinates when map stops moving
    const onMapIdle = useCallback(() => {
        if (mapRef) {
            const center = mapRef.getCenter();
            if (center) {
                const newPosition = {
                    lat: center.lat(),
                    lng: center.lng()
                };
                setMapCenter(newPosition);
                onLocationChange(newPosition);
            }
        }
    }, [mapRef, onLocationChange]);

    if (!isLoaded) {
        return <div className="location-picker-loading">Chargement de la carte...</div>;
    }

    return (
        <div className="location-picker">
            <p className="location-picker__instructions">
                📍 Déplacez la carte pour positionner le marqueur au bon endroit
            </p>

            <div style={{ position: 'relative' }}>
                <GoogleMap
                    mapContainerStyle={mapContainerStyle}
                    center={mapCenter}
                    zoom={15}
                    onLoad={onMapLoad}
                    onIdle={onMapIdle}
                    options={{
                        streetViewControl: false,
                        mapTypeControl: false,
                        fullscreenControl: false
                    }}
                >
                </GoogleMap>

                {/* Fixed center pin */}
                <div className="location-picker__center-pin">
                    <div className="location-picker__pin-icon">📍</div>
                </div>
            </div>

            <div className="location-picker__coords">
                <small>
                    Coordonnées: {mapCenter.lat.toFixed(6)}, {mapCenter.lng.toFixed(6)}
                </small>
            </div>
        </div>
    );
};

export default LocationPicker;
